import {BASIC_ME_DRAW} from "../../constants/store";

export const me_draw = (state = null, action) => {
  switch (action.type) {
    case BASIC_ME_DRAW:
      return action.payload === null ? null : Object.assign({}, action.payload);
    default:
      return state
  }
};